import ApplicationController from './application_controller';
/**
 * Priority+ tab strip: tabs that don't fit on one row collapse into a "More"
 * dropdown pinned at the right end. Recalculates on window resize, so the
 * dropdown always holds exactly the tabs that are currently clipped.
 *
 * Usage:
 *   <div data-controller="priority-nav" data-action="resize@window->priority-nav#update">
 *     <ul class="nav nav-pills top-tab-nav" data-priority-nav-target="strip">
 *       <li class="nav-item">...</li>
 *       ...
 *       <li class="nav-item ml-auto d-none" data-priority-nav-target="more">
 *         <div class="dropdown">
 *           <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown"
 *              data-priority-nav-target="moreToggle">More</a>
 *           <div class="dropdown-menu dropdown-menu-right" data-priority-nav-target="menu"></div>
 *         </div>
 *       </li>
 *     </ul>
 *   </div>
 */
export default class extends ApplicationController {
  static targets = ['strip', 'more', 'moreToggle', 'menu'];

  connect() {
    // Without JS the strip keeps Bootstrap's default wrap (master behavior);
    // from here on it is a single row and we manage the overflow ourselves.
    this.stripTarget.classList.add('flex-nowrap');
    this.update();
  }

  update() {
    const strip = this.stripTarget;
    const tabs = Array.from(strip.children).filter((li) => li !== this.moreTarget);
    if (tabs.length === 0) return;

    // Show everything so natural single-row positions can be measured
    tabs.forEach((li) => li.classList.remove('d-none'));
    this.moreTarget.classList.remove('d-none');

    const paddingRight = parseFloat(getComputedStyle(strip).paddingRight) || 0;
    const rowEnd = strip.clientWidth - paddingRight;
    const lastTab = tabs[tabs.length - 1];

    if (lastTab.offsetLeft + lastTab.offsetWidth <= rowEnd) {
      this.moreTarget.classList.add('d-none');
      this.menuTarget.innerHTML = '';
      return;
    }

    const limit = rowEnd - this.moreTarget.offsetWidth;
    const clipped = tabs.filter((li) => li.offsetLeft + li.offsetWidth > limit);
    clipped.forEach((li) => li.classList.add('d-none'));

    this.menuTarget.innerHTML = '';
    let anyActive = false;
    clipped.forEach((li) => {
      const link = li.querySelector('a');
      if (!link) return;
      const active = link.classList.contains('active');
      anyActive = anyActive || active;
      const item = link.cloneNode(true);
      item.className = `dropdown-item${active ? ' active' : ''}`;
      this.menuTarget.appendChild(item);
    });
    this.moreToggleTarget.classList.toggle('active', anyActive);
  }
}
